import { queryOptions, useQuery } from '@tanstack/react-query';

import { collectionsApi } from '../api/collections-api';

import { collectionKeys } from './collection-keys';

/** `productId` is the master product id, not the store product's. */
export function productCollectionsQueryOptions(storeId: string, productId: string) {
  return queryOptions({
    queryKey: collectionKeys.forProduct(storeId, productId),
    queryFn: () => collectionsApi.forProduct(storeId, productId),
  });
}

export function useProductCollections(storeId: string, productId: string) {
  return useQuery(productCollectionsQueryOptions(storeId, productId));
}
